import React, { useState } from "react";
import Button from "../../../componentLibrary/Button";
import ConfirmationBox from "../../../componentLibrary/ConfirmationBox";

export default function ConfirmationBoxComponent() {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  return (
    <div className="space-y-2">
      <h2 className="underline">Confirmation Components</h2>

      <h3>Confirmation Box</h3>
      <div className="mb-4 p-4 bg-gray-50 rounded-lg">
        <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
        <p className="text-sm text-gray-700">
          Confirmation dialogs used for important user actions that require
          explicit confirmation. Used for destructive actions like deletions,
          important decisions, and critical user choices. Features customizable
          messages, titles, and button text.
        </p>
      </div>
      <Button
        className="w-full"
        onClick={() => setIsConfirmOpen(true)}
        variant="secondary"
      >
        Show Confirmation Box
      </Button>
      <ConfirmationBox
        isOpen={isConfirmOpen}
        title="Delete Action"
        message={
          <p>
            Are you sure you want to delete the action:{" "}
            <span className="font-bold">Morning Walk</span>
          </p>
        }
        confirmText="Yes, Delete"
        cancelText="No, Cancel"
        onConfirm={() => {
          setIsConfirmOpen(false);
          // Handle confirmation
        }}
        onCancel={() => setIsConfirmOpen(false)}
      />
    </div>
  );
}
